import styled from 'styled-components';

export const OptionItemSpriteListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
`;

export const OptionItemSpriteStyles = styled.div<{
  isSelected: boolean;
  theme?: 'violet';
}>`
  body.dark & {
    ${({ theme }) => {
      if (theme === 'violet') {
        return `
          --bg-color: #765279;
          --bg-color-selected: #FFC9FB;
        `;
      }

      return `
        --bg-color: #30283e;
        --bg-color-selected: #2d1a55;
      `;
    }}
  }

  --bg-color: #ffffff80;
  --bg-color-selected: #ece4fd;
  box-sizing: border-box;
  height: 86px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  background-color: ${({ isSelected }) =>
    isSelected ? 'var(--bg-color-selected)' : 'var(--bg-color)'};
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  user-select: none;

  ${({ isSelected, theme }) => {
    if (isSelected) {
      switch (theme) {
        case 'violet':
          return `
          .option-item-sprite-title {
            color: #171123;
          }
        `;
        default:
          return `
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: transparent;
                border: 2px solid #803eff;
                box-sizing: border-box;
                border-radius: 16px;
                z-index: 2;
            }
        `;
      }
    }
  }}
`;

export const OptionItemSpriteImageContainerStyles = styled.div`
  width: 224px;
  aspect-ratio: 3.75;
  position: absolute;
  right: -12px;
  z-index: 1;
  font-size: 0;
  line-height: 0;

  img {
    width: 100%;
    height: 100%;
  }
`;
